import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import './css/setting.css';
import { DocumentEditor } from "@onlyoffice/document-editor-react";
import ButtonComp from "../components/button/ButtonComp";
import { formatIndianDate } from "../utils/Constant";
import CustomSearch from "../components/search/CustomSearch";
import { getAllISOCodes } from "iso-country-currency";
import { isNumberCheck } from '../utils/service/formValidation'
import {
  LoadingOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  DeleteOutlined,
  CloseCircleOutlined, CrownOutlined,
  LaptopOutlined,
  ReadOutlined,
  CalendarOutlined,
  LeftOutlined,
  RightOutlined,
  EditOutlined
} from "@ant-design/icons";
import {
  Badge,
  Descriptions,
  Button,
  Input,
  Space,
  Modal,
  message,
  Form,
  Popconfirm,
  Tabs,
  Table,
  Col,
  Tooltip,
  Spin,
  Typography,
  Card,
  Calendar,
  List,
} from "antd";
import Select from "react-select";

import {
  settingsUpdate,
  settingsUpdateError,
} from "../components/messages/ResponseMessages";
import UserTab from "./setting/userTabSection/userTab.jsx";
import AddModel from "./addModel";
import DownloadTab from "./setting/downloadTab";
import BulkUploadTab from "./setting/bulkUploadTab";
import TicketList from "./supportSystem/ticketList";
import Meeting from "./setting/MeetingManage/Meeting";
import axiosInstance from "../utils/axiosInstance.js";
import { useDispatch, useSelector } from "react-redux";
import { setStoreDetails } from "../app/slice/authSlice.js";
import RightArrowIcon from "../components/icons/RightArrowIcon.jsx";
import HoverIcon from "../components/icons/HoverIcon.jsx";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

const { TextArea } = Input;
const { TabPane } = Tabs;

const SettingsPage = () => {
  const select = useSelector((state) => state.auth);
  const company_id = select.userInfo.company_id;
  const user_role = select.userInfo.role;
  const token = select.accessToken;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "1";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [company, setCompany] = useState();
  const [countries, setCountries] = useState();
  const [states, setStates] = useState();
  const [editMode, setEditMode] = useState(false);
  const [isCompanyCreateModalOpen, setIsCompanyCreatedModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editedCompany, setEditedCompany] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProductModal, setIsProductModal] = useState(false);
  const [companyID, setCompanyID] = useState(true);
  const [products, setProducts] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [isExtraFieldModalOpen, setIsExtraFieldModalOpen] = useState(false);
  const [finalPage, setFinalPage] = useState(6);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [companyId, setCompanyId] = useState([]);
  const [activeOpen, setActiveOpen] = useState(false);
  const [allCurrency, setAllCurrency] = useState([]);
  const modalText = "Are you sure you want to Activate this user?";
  const [demoRequests, setDemoRequests] = useState([]);
  const [isCustomFieldEditMode, setIsCustomFieldEditMode] = useState(false)
  const [editableExterFieldData, setEditableExterFieldData] = useState([])
  const [isEdtBaCurr, setIsEdtBaCurr] = useState('false')
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isReadNotesModalOpen, setIsReadNotesModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [noteInput, setNoteInput] = useState("");
  const [noteLoading, setNoteLoading] = useState(false);
  const [noteList, setNoteList] = useState([]);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [rescheduleTime, setRescheduleTime] = useState(null);
  const [meetingIdToReschedule, setMeetingIdToReschedule] = useState(null);
  const [availableData, setAvailableData] = useState({});
  const [unavailableData, setUnavailableData] = useState({});
  const [bookedSlots, setBookedSlots] = useState(unavailableData);
  const [selectedTimezone, setSelectedTimezone] = useState("Asia/Kolkata");
  const [timezoneAdjustedData, setTimezoneAdjustedData] = useState({});
  const [timezoneAdjustedUnavailable, setTimezoneAdjustedUnavailable] = useState({});
  const [form] = Form.useForm();
  const [addDepartmentFrom] = Form.useForm();
  const [addProductFrom] = Form.useForm();
  const chatContainerRef = useRef(null);

  const checkProduct = async () => {
    try {
      const response = await axiosInstance.get(`/contract/check_product/?company=${company_id}`, {
        customParams: config
      });
      setIsEdtBaCurr(response.data.product)
    } catch (error) {
      console.error("Error fetching demo requests:", error?.message);
    }
  };

  const fetchDemoRequests = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/demo/list/`, {
        customParams: config
      });
      setDemoRequests(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching demo requests:", error.message);
      setLoading(false);
    }
  };

  const fetchCompanies = async (search) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/company/get/`, {
        customParams: { params: { search: search } }
      });
      console.log(response, "ressssssssssssssss")
      setAllCompanies(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const onPrimum = async (value, user_id) => {
    try {
      const payload = {
        user_id,
        is_premium: value
      }
      const res = await axiosInstance.post('/is_premium/', payload);
      message.success('Succesfully Update .')
      fetchCompanies()

    } catch (error) {
      console.log('error', error)
      message.error(error?.response?.data?.error)
    }
  }

  const companiesColumns = [
    {
      title: "Company Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Admin Contact No.",
      dataIndex: "admin_contact_number",
      key: "admin_contact_number",
    },
    {
      title: "Admin Name",
      dataIndex: "name_of_admin",
      key: "name_of_admin",
    },
    {
      title: "Admin Email",
      dataIndex: "admin_email",
      key: "admin_email",
    },
    {
      title: "Valid From",
      dataIndex: "valid_from",
      key: "valid_from",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Valid To",
      dataIndex: "valid_to",
      key: "valid_to",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Change Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (text, record) => (
        <>
          {record.is_active ? (
            <div
              onClick={() => showADeactivateeModal(record.id)}
              type="submit"
              className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-red-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
            >
              Deactivate
            </div>
          ) : (
            <div
              onClick={() => showCompanyActiveModal(record.id)}
              className="inline-block rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
            >
              Activate
            </div>
          )}
        </>
      ),
    },
    {
      title: "Premium",
      dataIndex: "is_premium",
      key: "is_premium",
      render: (text, record) => (
        <Tooltip title={record.is_premium ? 'Premium' : 'Non Premium'}>
          <Button
            type="primary"
            shape="circle"
            size="large"
            onClick={() => onPrimum(!record.is_premium, record?.user_id)}
            icon={
              record.is_premium ? (
                <CrownOutlined className="text-yellow-400 text-2xl" />
              ) : (
                <CloseCircleOutlined className="text-gray-500 text-2xl" />
              )
            }
            className="w-16 h-16 flex items-center justify-center shadow-lg hover:shadow-xl transition duration-300"
          />
        </Tooltip>
      ),
    },
    {
      title: "View details",
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => (
        <Link
          to={{
            pathname: `/admin/company/${record.id}`,
          }}
        >
          <button
            type="submit"
          >
            <RightArrowIcon />
          </button>
          {/* <Button
            type="submit"
            className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-blue-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
          >
            View details
          </Button> */}
        </Link>
      ),
    },
  ];

  const handleOk = () => {
    form.submit();
  };

  const departments = company && company.department_list;

  const fetchProduct = async () => {
    try {
      const response = await axiosInstance.get(`/company/get_product/`, {
        customParams: config
      });
      setProducts(response.data.data); // Update the state with the fetched user data
    } catch (error) {
      console.log('error', error)
    }
  };

  const handleDepartment = (values) => {
    values.department_list.push(...departments);

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, values).then((response) => {
      // Handle successful response
      setEditMode(false);
      settingsUpdate(response.data.message);
      fetchCompanys();
      setIsModalOpen(false);
      addDepartmentFrom.resetFields();
    })
      .catch((error) => {
        message.error("Some error occured while updating. Please try again.");
        // settingsUpdateError(
        //   "Some error occured while updating. Please try again."
        // );
      });

    setEditMode(false);
  };

  const handleProduct = (values) => {
    const product_list = [
      ...products.map((item) => item.product_name),
      ...(Array.isArray(values.product_list) ? values.product_list : []),
    ];

    axiosInstance.put(`/company/add_product/`, { product_list })
      .then((response) => {
        // Handle successful response
        setEditMode(false);
        setIsProductModal(false);
        settingsUpdate(response.data.message);
        fetchProduct();
        addProductFrom.resetFields();
      })
      .catch((error) => {
        settingsUpdateError(
          "Some error occured while updating. Please try again."
        );
      });
  };

  const deleteDepartment = (values) => {
    let data = {
      department_list: departments.filter((item) => item !== values),
    };

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, data)
      .then((response) => {
        // Handle successful response
        message.success("Department successfully deleted.");
        fetchCompanys();
      })
      .catch((error) => {
        message.error("An error occured.");
        console.error("Error updating user details:", error);
      });
  };

  const deleteProduct = (values) => {
    let data = products
      .filter((item) => item.product_name !== values)
      .map((item) => item.product_name);

    axiosInstance.put(`/company/add_product/`, { product_list: data })
      .then((response) => {
        // Handle successful response
        message.success("Product successfully deleted.");
        fetchProduct();
      })
      .catch((error) => {
        message.error("An error occured.");
        console.error("Error updating user details:", error);
      });
  };

  const handleFinishExtraField = (values, data) => {
    let transformedObject, newKey;
    if (values === 'editCustomField') {
      if (!data) {
        const hasEmptyValues = editableExterFieldData?.flat()?.some(value => !value.trim());
        if (hasEmptyValues) {
          message.error('Every field should be fill up in custom tab')
          return false;
        }
      }
      newKey = data ? Object.fromEntries(data) : Object.fromEntries(editableExterFieldData);
    } else {
      transformedObject = values?.extra_fields?.reduce((acc, obj) => {
        const { field, value } = obj;
        acc[field] = value;
        return acc;
      }, {});
      newKey = { ...transformedObject, ...company?.extra_field };
    }

    axiosInstance.patch(`/company/${company_id && company_id}/update/`, { extra_field: newKey })
      .then((response) => {
        // Handle successful response
        fetchCompanys();
        if (values === 'editCustomField') {
          setIsCustomFieldEditMode(false);
          return;
        }
        setEditMode(false);
        settingsUpdate(response.data.message);
        setIsExtraFieldModalOpen(false);
        form.resetFields();
      })
      .catch((error) => {
        settingsUpdateError(
          "Some error occured while updating. Please try again."
        );
        console.error("Error updating user details:", error);
      });

    setEditMode(false);
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const showCompanyActiveModal = (companyId) => {
    setActiveOpen(true);
    setCompanyId(companyId);
  };
  const showADeactivateeModal = (companyId) => {
    setDeactivateModal(true);
    setCompanyId(companyId);
  };
  const showCompanyCreateModal = () => {
    setIsCompanyCreatedModalOpen(true);
  };
  const showProductModal = () => {
    setIsProductModal(true);
  };
  const showExtraFieldModal = () => {
    setIsExtraFieldModalOpen(true);
  };
  const handleOkExtraField = () => {
    setIsExtraFieldModalOpen(false);
  };
  const handleOkCompanyCreate = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
    // setIsCompanyCreatedModalOpen(false);
    console.log(values);
  };
  const handleCancelModal = () => {
    setIsModalOpen(false);
    setIsExtraFieldModalOpen(false);
    setIsProductModal(false);
    setIsCompanyCreatedModalOpen(false);
    setDeactivateModal(false);
    form.resetFields();
  };
  const handleCancelExtraFieldModal = () => {
    setIsExtraFieldModalOpen(false);
  };
  const handleEdit = () => {
    if (
      (user_role && user_role.toLowerCase() === "admin") ||
      user_role.toLowerCase() === "superadmin"
    ) {
      setEditMode(true);
    }
  };

  const fetchState = async (value) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: value.value,
        },
      });

      setStates(response.data); // Update the state with the fetched user data
    } catch (error) { }
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditedCompany({ ...company });
    setActiveOpen(false);
    setIsCompanyCreatedModalOpen(false);
    setDeactivateModal(false);
    form.resetFields();
  };

  const handleCountryChange = (value) => {
    form.setFieldsValue({ "address.country": value });
    // form.setFieldsValue({ "address.state": null });

    setCompanyID(value.value);
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        country: value.value,
      },
    }));
    fetchState(value);
  };

  const handleAdress1Change = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handleAddress2Change = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };
  const handleCityChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handlePinChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        [name]: value,
      },
    }));
  };

  const handleStateChange = (value) => {
    console.log(value, "KJSHDjkahsdjkhasd");
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      address: {
        ...prevAddress.address,
        state: value.value,
      },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevCompany) => ({
      ...prevCompany,
      [name]: value,
    }));
  };

  const fetchCompanys = async () => {
    try {
      const response = await axiosInstance.get(`/company/${company_id && company_id}/get/`, {
        customParams: config
      });

      setCompany(response.data);
      setEditedCompany(response.data);
      dispatch(setStoreDetails({ currency: response.data.currency }))
      const {
        address: { state, country, ...addressWithoutCountryState },
        ...otherData
      } = response.data;
      const editedCompany = {
        address: {
          ...addressWithoutCountryState,
          country: country && country.id,
          state: state && state.id,
        },
        ...otherData,
      };
      setEditedCompany(editedCompany);
    } catch (error) { }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", key);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };

const handleNext = () => {
  form.validateFields().then(() => {
    const nextTab = (parseInt(activeTab, 10) % finalPage) + 1;
    const nextTabStr = nextTab.toString();
    setActiveTab(nextTabStr);

    const newParams = new URLSearchParams(location.search);
    newParams.set("tab", nextTabStr);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  });
};

const handlePrevious = () => {
  const previousTab = ((parseInt(activeTab, 10) - 2 + finalPage) % finalPage) + 1;
  const previousTabStr = previousTab.toString();
  setActiveTab(previousTabStr);

  const newParams = new URLSearchParams(location.search);
  newParams.set("tab", previousTabStr);
  navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
};


  const handleCompanyStatus = (action) => {
    const reason = form.getFieldValue('reason');
    if (!reason && action === "deactivate") {
      return false;
    }
    const payload = {
      active: action === "deactivate" ? false : true,
      ...(action === "deactivate" && { reason }),
    }
    axiosInstance.put(`/company/${companyId}/active/`, payload)
      .then((response) => {
        if (response.status === 200) {
          form.resetFields();
          setDeactivateModal(false);
          setActiveOpen(false);
          fetchCompanies();
          message.success("Company deactivated successfully.");
        } else {
          setDeactivateModal(false);
          setActiveOpen(false);
          message.error("An error occured. Please try again.");
        }
      })
      .catch((error) => {
        setDeactivateModal(false);
        setActiveOpen(false);

        message.error(error?.response?.data.error);
      });
  };
  const onFinish = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
    setEditedCompany({ ...editedCompany, name: values.name });
    try {

      axiosInstance.patch(`/company/${company_id && company_id}/update/`, editedCompany)
        .then((response) => {
          setEditMode(false);
          fetchCompanys();
          settingsUpdate(response.data.message);
        })
        .catch((error) => {
          setEditMode(false);
          message.error(error.response.data.error);
        });
    } catch (errorInfo) {
      console.log(errorInfo);
      // setActiveTab("1");
      const errorFields = errorInfo.errorFields[0].name;
      message.error(`Form validation failed, please check all the fields.`);
    }
  };
  const handleCompanyCreate = async () => {
    await form.validateFields();
    const values = await form.getFieldsValue();
  };

  const handleCurrencyChange = (value) => {
    setEditedCompany((prevAddress) => ({
      ...prevAddress,
      currency: value.value,
    }));
  };

  const handleCompanySearch = (value) => {
    config.search = value;
    fetchCompanies(value);
  };

  const handelCloseCustomFieldEditMode = () => {
    setIsCustomFieldEditMode(false);
    setOriginalCustomFields()
  }

  const handleCustomFormChange = (value, index, name) => {
    const updatedCustomForm = [...editableExterFieldData];
    if (name === "field") {
      updatedCustomForm[index][0] = value;
    } else {
      updatedCustomForm[index][1] = value
    }
    setEditableExterFieldData([...updatedCustomForm])
  }
  const customTabColumns = useMemo(() => {
    return [
      {
        title: "Particular",
        dataIndex: "field",
        render: (_, record, index) => (
          <>
            {isCustomFieldEditMode ? (
              <Input
                name={"field"}
                defaultValue={record[0]}
                onChange={(e) =>
                  handleCustomFormChange(e.target.value, index, e.target.name)
                }
              />
            ) : (
              <h1>{record[0]}</h1>
            )}
          </>
        ),
      },

      {
        title: "Details",
        dataIndex: "value",
        render: (_, record, index) => (
          <>
            {isCustomFieldEditMode ? (
              <Input
                name={"value"}
                defaultValue={record[1]}
                onChange={(e) =>
                  handleCustomFormChange(e.target.value, index, e.target.name)
                }
              />
            ) : (
              <h1>{record[1]}</h1>
            )}
          </>
        ),
      },
      ...(!isCustomFieldEditMode && (
        !isCustomFieldEditMode && (user_role && user_role.toLowerCase() === "admin" ||
          user_role.toLowerCase() === "superadmin")
      )
        ? [
          {
            title: "Delete Field",
            dataIndex: "age",
            key: "age",
            render: (_, record, index) => (
              <span>
                <Popconfirm
                  title="Delete Custom Field"
                  description="Are you sure to delete this Field?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => {
                    setOriginalCustomFields()
                    const tempData = [...editableExterFieldData];
                    tempData.splice(index, 1);
                    handleFinishExtraField('editCustomField', tempData)
                    setEditableExterFieldData([...tempData])
                  }
                  }
                >
                  <Button danger>
                    <DeleteOutlined />
                  </Button>
                </Popconfirm>
              </span>
            ),
          },
        ]
        : []),
    ];
  }, [editableExterFieldData, isCustomFieldEditMode])

  const setOriginalCustomFields = () => {
    if (company?.extra_field) {
      setEditableExterFieldData(Object.entries(company.extra_field))
    }
  }

  const renderGroupedNotes = () => {
    const groups = {};

    noteList.forEach((note) => {
      const date = dayjs(note.created_at);
      let label = date.format("DD MMM YYYY");
      if (date.isToday()) label = "Today";
      else if (date.isYesterday()) label = "Yesterday";

      if (!groups[label]) groups[label] = [];
      groups[label].push(note);
    });

    return Object.entries(groups).map(([label, notes]) => (
      <div key={label} style={{ marginBottom: "16px" }}>
        <h3 className="text-sm text-gray-500 font-medium mb-2">{label}</h3>

        {notes.map((note) => (
          <div
            key={note.id}
            style={{
              backgroundColor: "#2563EB",
              padding: "10px 14px",
              borderRadius: "12px",
              marginTop: "8px",
              maxWidth: "80%",
              color: "white",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "14px",
                lineHeight: "1.4",
                wordBreak: "break-word",
              }}
            >
              {note.note}
            </p>
            <div
              style={{
                fontSize: "11px",
                textAlign: "right",
                marginTop: "6px",
                color: "#d1d5db", // Tailwind's gray-300
              }}
            >
              {dayjs(note.created_at).format("h:mm A")}
            </div>
          </div>
        ))}
      </div>
    ));
  };

  const handleOpenNoteModal = async (record) => {
    setSelectedRecord(record);
    setNoteInput("");
    setNoteList([]);
    setNoteLoading(true);
    try {
      const res = await axiosInstance.get(`/demo/${record.id}/notes/`);
      setNoteList(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch note:", err);
    }

    setNoteLoading(false);
    setIsReadNotesModalOpen(true);
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, 200);
  };

  const handleNoteSubmit = async () => {
    if (!noteInput.trim()) return;
    setNoteLoading(true);

    try {
      await axiosInstance.post(`/demo/${selectedRecord.id}/add-note/`, {
        note: noteInput,
      });
      setNoteInput("");
      // Re-fetch notes
      const res = await axiosInstance.get(`/demo/${selectedRecord.id}/notes/`);
      setNoteList(res?.data || []);
      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 200);
    } catch (err) {
      console.error("Failed to add note:", err);
      message.error("Failed to add note.");
    }

    setNoteLoading(false);
  };

  const generateAvailableSlots = (timezone = "Asia/Kolkata") => {
    const slots = {};
    const startHour = 10;
    const endHour = 18;

    for (let i = 0; i < 30; i++) {
      const date = dayjs().tz(timezone).add(i, "day");
      const dayOfWeek = date.day(); // 0 (Sunday) - 6 (Saturday)

      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        // Only Monday - Friday
        const formattedDate = date.format("YYYY-MM-DD");
        slots[formattedDate] = [];

        for (let hour = startHour; hour < endHour; hour++) {
          slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:00`);
          slots[formattedDate].push(`${hour.toString().padStart(2, "0")}:30`);
        }
      }
    }
    return slots;
  };

  const convertTime = (time, date, selectedTimezone, localTimeZone) => {
    const localDateTime = dayjs.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", localTimeZone).tz(selectedTimezone);
    const adjustedDate = localDateTime.format("YYYY-MM-DD");
    const adjustedTime = localDateTime.format("HH:mm");
    return { adjustedDate, adjustedTime }
  }
  const getDate = async () => {
    try {
      const response = await axiosInstance.get(`/demo/busy-slots/`);
      setUnavailableData(response.data.blocked_slots);
    } catch (error) {
      message.error(error.response.data.error);
    }
  }
  if (rescheduleLoading) {
    message.loading("Rescheduling meeting...", 0);
  }
  const dateCellRender = (value) => {
    return timezoneAdjustedData[value.format("YYYY-MM-DD")] ? null : <div style={{ color: "#bbb" }}></div>;
  };

  const isPast = (date, slot) => dayjs.tz(`${date} ${slot}`, "YYYY-MM-DD HH:mm", selectedTimezone).isBefore(dayjs().tz(selectedTimezone));

  const getFormattedDate = (date) => {
    if (!date) return "";
    const dayjsDate = dayjs(date);
    const day = dayjsDate.date();
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th"; // 11-13
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const suffix = getOrdinal(day);
    const formatted = `${dayjsDate.format("dddd, MMMM")} ${day}${suffix} ${dayjsDate.format("YYYY")}`;
    return formatted;
  };

  useEffect(() => {
    const rawAvailableData = Object.keys(availableData).length > 0 ? { ...availableData } : generateAvailableSlots(selectedTimezone);
    const adjustTimeData = (data) => {
      const adjustedData = {};
      Object.keys(data).forEach((date) => {
        data[date].forEach((time) => {
          const { adjustedDate, adjustedTime } = convertTime(time, date, selectedTimezone, "Asia/Kolkata");
          if (!adjustedData[adjustedDate]) adjustedData[adjustedDate] = [];
          adjustedData[adjustedDate].push(adjustedTime);
        });
      });
      return adjustedData;
    };


    const adjustedAvailableData = adjustTimeData(rawAvailableData);
    const adjustedUnavailableData = adjustTimeData(bookedSlots);
    setTimezoneAdjustedData(adjustedAvailableData);
    setTimezoneAdjustedUnavailable(adjustedUnavailableData);
  }, [selectedTimezone, availableData, bookedSlots]);

  useEffect(() => {
    setBookedSlots(unavailableData);
  }, [unavailableData]);

  useEffect(() => {
    if (company?.extra_field) {
      setOriginalCustomFields()
    }
  }, [company?.extra_field])

  useEffect(() => {
    getDate()
  }, []);

  useEffect(() => {
    fetchProduct();
    if (user_role === "superadmin") {
      fetchCompanies();
    }
  }, []);
  useEffect(() => {
    const userNavigate = localStorage.getItem("gyrwmnqijpkl")
    if (userNavigate === "xvzndrpkloqy") {
      setActiveTab("5");
      localStorage.removeItem("gyrwmnqijpkl");
    } else if (userNavigate === "xvzndrpkloqo9") {
      setActiveTab("7");
      localStorage.removeItem("gyrwmnqijpkl");
    }
  }, []);
  useEffect(() => {
    fetchCompanys();
  }, [editMode]);

  useEffect(() => {
    if (!company || !company.address || !company.address.country) return;
    fetchState({ value: company.address.country.id });
  }, [company]);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get("/country/get/");
        setCountries(response.data); // Update the state with the fetched user data
      } catch (error) { }
    };
    fetchCountry();
  }, []);

  useEffect(() => {
    if (user_role === "superadmin" || user_role === "demo") {
      fetchDemoRequests();
    }
  }, [user_role, token]);

  const config = {
    search: ""
  };

  useEffect(() => {
    if (user_role === "superadmin") {
      setFinalPage(10);
    } else if (user_role === "admin") {
      setFinalPage(7);
    } else {
      setFinalPage(6);
    }
  }, [user_role]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const codes = await getAllISOCodes();
        const transformedData = codes.map((code) => ({
          value: `${code.countryName} (${code.symbol})`,
          label: `${code.countryName} (${code.symbol})`,
        }));
        setAllCurrency(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    checkProduct()
  }, []);


  return (
    <>
      {company ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              encType="multipart/form-data"
            >
              <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                type="card"
                style={{ flex: 1 }}
              >
                <TabPane tab="Company Details" key="1">
                  <div className=" text-black pb-3 px-2 flex items-center justify-between">
                    <span>
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Company Details
                      </h1>
                    </span>

                    {((user_role && user_role.toLowerCase() === "admin") ||
                      user_role.toLowerCase() === "superadmin") &&
                      !editMode ? (
                      <Button
                        type=""
                        style={{
                          border: "1px solid #4E36A3",
                          color: "#4E36A3",
                          height: "40px", // Adjust height for desired size
                          width: "120px",
                        }}
                        onClick={handleEdit}
                      >
                        Edit
                      </Button>
                    ) : null}
                  </div>

                  <Descriptions
                    title=""
                    layout="vertical"
                    className=""
                    bordered
                  >
                    <Descriptions.Item label="Company Name" span={2}>
                      {editMode && editedCompany ? (
                        <Input
                          name="name"
                          value={editedCompany.name}
                          onChange={handleInputChange}
                        />
                      ) : (
                        company.name
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Base Currency" span={2}>
                      {editMode && !isEdtBaCurr && editedCompany ? (
                        <Select
                          options={allCurrency}
                          onChange={handleCurrencyChange}
                          defaultValue={allCurrency.find(
                            (currency) => currency.value === company.currency
                          )}
                        />
                      ) : (
                        company.currency
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Active Status">
                      {!company.is_active ? (
                        <Badge color="red" status="" text="Inactive" />
                      ) : (
                        <Badge status="success" text="Running" />
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Admin's Name">
                      {company.name_of_admin}
                    </Descriptions.Item>
                    <Descriptions.Item label="Admin's Contact Number">
                      {editMode && editedCompany ? (
                        <Input
                          name="admin_contact_number"
                          value={editedCompany.admin_contact_number}
                          onChange={(e) => {
                            if (isNumberCheck(e.target.value)) {
                              handleInputChange(e);
                              return;
                            }
                            message.error("Please enter only numerical value.");
                          }}
                        />
                      ) : (
                        company.admin_contact_number
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Admin's Email">
                      {/* {editMode && editedCompany ? (
                        <Input
                          name="admin_email"
                          value={editedCompany.admin_email}
                          onChange={handleInputChange}
                        />
                      ) : ( */}
                      {company.admin_email}
                      {/* )} */}
                    </Descriptions.Item>
                    <Descriptions.Item label="Company License No.">
                      <Form.Item
                        name="name"
                        // rules={[
                        //   {
                        //     validator: validateInput,
                        //   },
                        // ]}
                        style={{ marginBottom: 0 }} // Set marginBottom to 0
                      // hasFeedback
                      >
                        {editMode && editedCompany ? (
                          <Input
                            onChange={handleInputChange}
                            value={editedCompany.cin}
                            name="cin"
                            defaultValue={editedCompany.cin}
                          />
                        ) : (
                          <span>{company.cin}</span>
                        )}
                      </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="Company's Contact Number">
                      {editMode && editedCompany ? (
                        <Input
                          name="contact_no"
                          value={editedCompany.contact_no}
                          onChange={(e) => {
                            if (isNumberCheck(e.target.value)) {
                              handleInputChange(e);
                              return;
                            }
                            message.error("Please enter only numerical value.");
                          }}
                        />
                      ) : (
                        company.contact_no
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="TAX License No.">
                      <Form.Item
                        name="gst_number"
                        // rules={[
                        //   {
                        //     validator: validateGSTNumber,
                        //   },
                        // ]}
                        style={{ marginBottom: 0 }} // Set marginBottom to 0
                      // hasFeedback
                      >
                        {editMode && editedCompany ? (
                          <Input
                            onChange={handleInputChange}
                            value={editedCompany.gst_number}
                            name="gst_number"
                            defaultValue={editedCompany.gst_number}
                          />
                        ) : (
                          <span>{company.gst_number}</span>
                        )}
                      </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="Domain">
                      {company.domain}
                    </Descriptions.Item>
                    <Descriptions.Item label="Number of Licence">
                      {company.number_of_licence}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Users">
                      {company.user_count}
                    </Descriptions.Item>
                  </Descriptions>

                  <Descriptions
                    title="Full Address"
                    layout="vertical"
                    className="mt-4"
                    bordered
                  >
                    <Descriptions.Item label="Address Line 1">
                      {editMode && editedCompany ? (
                        <>
                          {/* <Form.Item name={["address", "address1"]}>
                          <Input
                            defaultValue={editedCompany.address.address1}
                            onChange={handleAdress1Change}
                          />
                        </Form.Item> */}
                          <Input
                            name="address1"
                            defaultValue={editedCompany.address.address1}
                            onChange={handleAdress1Change}
                          />
                        </>
                      ) : (
                        company.address.address1
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address Line 2">
                      {editMode && editedCompany ? (
                        <Input
                          name="address2"
                          defaultValue={editedCompany.address.address2}
                          onChange={handleAddress2Change}
                        />
                      ) : (
                        company.address.address2
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="City">
                      {editMode && editedCompany ? (
                        <Input
                          name="city"
                          defaultValue={editedCompany.address.city}
                          onChange={handleCityChange}
                        />
                      ) : (
                        company && company.address.city
                      )}
                    </Descriptions.Item>
                    <Descriptions.Item label="PIN">
                      {editMode && editedCompany ? (
                        <Input
                          name="postal_code"
                          defaultValue={editedCompany.address.postal_code}
                          onChange={handlePinChange}
                        />
                      ) : (
                        company && company.address.postal_code
                      )}
                    </Descriptions.Item>

                    <Descriptions.Item label="Country">
                      {editMode && editedCompany ? (
                        <>
                          <Select
                            options={
                              countries &&
                              countries.map((country) => ({
                                // value: state.isoCode,
                                value: country.id,
                                label: country.name,
                              }))
                            }
                            menuPlacement="top"
                            required
                            onChange={handleCountryChange}
                            defaultValue={
                              company &&
                              company.address.country && {
                                value: company.address.country.id,
                                label: company.address.country.name,
                              }
                            }
                          />
                        </>
                      ) : (
                        company &&
                        company.address.country &&
                        company.address.country.name
                      )}
                    </Descriptions.Item>
                    {companyID && (
                      <Descriptions.Item label="State">
                        {editMode && editedCompany ? (
                          <>

                            <Select
                              options={
                                states &&
                                states.map((state) => ({
                                  // value: state.isoCode,
                                  value: state.id,
                                  label: state.name,
                                }))
                              }
                              menuPlacement="top"
                              onChange={handleStateChange}
                              defaultValue={
                                company &&
                                company.address.state && {
                                  value: company.address.state.id,
                                  label: company.address.state.name,
                                }
                              }
                            />
                          </>
                        ) : (
                          company &&
                          company.address.state &&
                          company.address.state.name
                        )}
                      </Descriptions.Item>
                    )}
                  </Descriptions>

                  {editMode && editedCompany && (
                    <div className="flex mt-6">
                      <Button onClick={handleCancel} className="">
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="ml-12"
                      >
                        Save
                      </Button>
                    </div>
                  )}
                </TabPane>
                <TabPane tab="Departments" key="2">
                  <div className=" text-black pb-3 px-2 flex items-center justify-between">
                    <span>
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Departments
                      </h1>
                    </span>
                    {/* <button className="bg-blue-500 text-white px-4 py-2 rounded">
                    Top Button
                  </button> */}
                    {(user_role && user_role.toLowerCase() === "admin") ||
                      user_role.toLowerCase() === "superadmin" ? (
                      <>
                        <ButtonComp
                          text="Add Departments"
                          bgColor="#4E36A3"
                          textColor="white"
                          onClick={showModal}
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  {company.department_list &&
                    company.department_list.map((department, index) => (
                      <>
                        <div className="bg-purple-50 py-2 px-5 mb-3">
                          <h1
                            key={department.id}
                            value={department.id}
                            className="mt-1"
                          >
                            <div className="delete_department">
                              <span>{department}</span>
                              {(user_role &&
                                user_role.toLowerCase() === "admin") ||
                                user_role.toLowerCase() === "superadmin" ? (
                                <span>
                                  <Popconfirm
                                    title="Delete Department"
                                    description="Are you sure to delete this department?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() =>
                                      deleteDepartment(department)
                                    }
                                    placement="bottomLeft"
                                  >
                                    <Button danger>
                                      <DeleteOutlined className="" />
                                    </Button>
                                  </Popconfirm>
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </h1>
                        </div>
                      </>
                    ))}
                  <AddModel title='Department Name' isOpen={isModalOpen} handleCancelModal={handleCancelModal}
                    from={addDepartmentFrom} name={['dynamic_form_item', 'department_list']} onFinish={handleDepartment} />
                </TabPane>
                <TabPane tab="Products / Services" key="3">
                  <div className=" text-black pb-3 px-2 flex items-center justify-between">
                    <span>
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Products / Services
                      </h1>
                    </span>
                    {/* <button className="bg-blue-500 text-white px-4 py-2 rounded">
                    Top Button
                  </button> */}
                    {(user_role && user_role.toLowerCase() === "admin") ||
                      user_role.toLowerCase() === "superadmin" ? (
                      <ButtonComp
                        text="Add Product / Service"
                        bgColor="#4E36A3"
                        textColor="white"
                        onClick={showProductModal}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <Descriptions.Item
                    label="Product / Service"
                    span={1}
                  // className="text-center"
                  >
                    {products &&
                      products.map((product, index) => (
                        <div key={product.id} className="bg-purple-50 py-2 px-5 mb-3">
                          <h1
                            key={product.id}
                            value={product.id}
                            className="mt-1 font-medium"
                          >
                            <div className="delete_department">
                              <span>{product.product_name}</span>
                              {(user_role &&
                                user_role.toLowerCase() === "admin") ||
                                user_role.toLowerCase() === "superadmin" ? (
                                <span>
                                  <Popconfirm
                                    title="Delete Product / Service"
                                    description="Are you sure to delete this Product / Service?"
                                    okText="Yes"
                                    cancelText="No"
                                    placement="bottomLeft"
                                    onConfirm={() =>
                                      deleteProduct(product.product_name)
                                    }
                                  >
                                    <Button danger>
                                      <DeleteOutlined />
                                    </Button>
                                  </Popconfirm>
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </h1>
                        </div>

                      ))}
                    <AddModel title='Product / Service Name' isOpen={isProductModal} handleCancelModal={handleCancelModal}
                      from={addProductFrom} name={['dynamic_form_product', 'product_list']} onFinish={handleProduct} />
                  </Descriptions.Item>
                </TabPane>
                <TabPane tab="Custom Fields" key="4">
                  <div className=" text-black pb-3 px-2 flex items-center justify-between">
                    <div className="agreement-details">
                      <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                        Custom Fields
                      </h1>
                      {!isCustomFieldEditMode && !!editableExterFieldData.length
                        && (user_role && user_role.toLowerCase() === "admin" ||
                          user_role.toLowerCase() === "superadmin") && (
                          <div className="edit-icon">
                            <EditOutlined
                              onClick={() => setIsCustomFieldEditMode(true)}
                              className="h-4 ml-2 text-lg transform scale-125"
                            />
                          </div>
                        )}
                    </div>
                    {(user_role && user_role.toLowerCase() === "admin") ||
                      user_role.toLowerCase() === "superadmin" ?
                      !isCustomFieldEditMode ? <ButtonComp
                        text="Add Custom Fields"
                        bgColor="#4E36A3"
                        textColor="white"
                        onClick={showExtraFieldModal}
                      /> : <div className="flex justify-between">
                        <div className="flex">
                          <ButtonComp
                            width="7em"
                            text={"Cancel"}
                            onClick={handelCloseCustomFieldEditMode}
                            margin={"4px"}
                            textColor="#4E36A3"
                          ></ButtonComp>
                          <ButtonComp
                            width="7em"
                            type="primary"
                            onClick={() =>
                              handleFinishExtraField('editCustomField')
                            }
                            className=""
                            text={"Save"}
                            textColor="white"
                            bgColor="#4E36A3"
                          ></ButtonComp>
                        </div>
                      </div>
                      : (
                        ""
                      )}
                    <Modal
                      title="Custom Fields"
                      open={isExtraFieldModalOpen}
                      onOk={handleOkExtraField}
                      onCancel={handleCancelExtraFieldModal}
                      footer={null}
                    >
                      <Form
                        form={form}
                        name="dynamic_form_nest_item"
                        onFinish={handleFinishExtraField}
                        style={{
                          maxWidth: 600,
                        }}
                        autoComplete="off"
                      >
                        <Form.List name="extra_fields">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }) => (
                                <Space
                                  key={key}
                                  style={{
                                    display: "flex",
                                    marginBottom: 8,
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    {...restField}
                                    name={[name, "field"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Missing Particular name",
                                      },
                                    ]}
                                  >
                                    <Input placeholder="Particular" />
                                  </Form.Item>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "value"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Missing value",
                                      },
                                    ]}
                                  >

                                    <Input.TextArea placeholder="Details" />
                                  </Form.Item>
                                  <MinusCircleOutlined
                                    onClick={() => remove(name)}
                                  />
                                </Space>
                              ))}
                              <Form.Item>
                                <Button
                                  type="dashed"
                                  onClick={() => add()}
                                  block
                                  icon={<PlusOutlined />}
                                >
                                  Add More fields
                                </Button>
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                        <Form.Item>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                    </Modal>
                  </div>
                  <Table
                    dataSource={editableExterFieldData}
                    columns={customTabColumns}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    bordered
                    className="mb-4"
                  />
                </TabPane>
                <TabPane tab="Users" key="5">
                  <UserTab />
                </TabPane>
                <TabPane tab="Download" key="6">
                  <div className="app">
                    <div className="financialYearsContainer">
                      <DownloadTab allExuonDate={editedCompany?.date_of_execution} exuonDate={editedCompany?.date_of_execution[0] || ''} />
                    </div>
                  </div>
                </TabPane>
                {user_role === "admin" && (
                  <TabPane tab="Bulk Upload" key="7">
                    <BulkUploadTab />
                  </TabPane>
                )}
                {user_role === "superadmin" && (
                  <TabPane tab="Companies" key="7">
                    <>
                      <div className=" text-black pb-3 px-2 flex items-center justify-between">
                        <span className="flex flex-row items-center">
                          <h1 className="mt-1 mr-4 text-3xl font-bold font-inter">
                            Companies
                          </h1>
                          <CustomSearch onSearch={handleCompanySearch} />
                        </span>

                        <ButtonComp
                          text="Add Companies"
                          bgColor="#4E36A3"
                          textColor="white"
                          onClick={showCompanyCreateModal}
                        />

                        <Modal
                          title="Add Company"
                          open={isCompanyCreateModalOpen}
                          onOk={handleOkCompanyCreate}
                          onCancel={handleCancel}
                          style={{ fontSize: "24px", padding: "40px" }}
                          okText="Create"
                          okButtonProps={{
                            style: {
                              backgroundColor: "#4E36A3",
                              color: "white",
                              height: "40px",
                              width: "100px",
                            },
                            disabled: loading, // Disable the button when loading is true
                          }} // Set background color for the Ok button
                          cancelButtonProps={{
                            style: {
                              backgroundColor: "",
                              color: "#4E36A3",
                              height: "40px",
                              width: "100px",
                            },
                          }} // Set background color for the Cancel button
                        >
                          {/* <p>{modalText}</p> */}
                          <Form form={form} onFinish={handleCompanyCreate}>
                            <Col>Name of User</Col>

                            <Form.Item label="" name="first_name">
                              <Input placeholder="" />
                            </Form.Item>
                            <Col>Company Name</Col>

                            <Form.Item label="" name="name">
                              <Input placeholder="" />
                            </Form.Item>
                            <Col>Email Address</Col>
                            <Form.Item label="" name="admin_email">
                              <Input placeholder="" />
                            </Form.Item>
                            <Col>Contact Number</Col>

                            <Form.Item label="" name="admin_contact_number">
                              <Input
                                placeholder=""
                                pattern="[0-9]{10}"
                                title="Please enter a 10-digit contact number."
                              />
                            </Form.Item>
                            <Col>Country</Col>

                            <Form.Item label="" name="country">
                              <Select
                                placeholder="Select Country"
                                onChange={handleCountryChange}
                                menuPlacement="top"
                                options={
                                  countries &&
                                  countries.map((country) => ({
                                    // value: state.isoCode,
                                    value: country.id,
                                    label: country.name,
                                  }))
                                }
                              />
                            </Form.Item>
                            {/* <Form.Item>
                              <Button
                                loading={isLoading}
                                type="submit"
                                htmlType="submit"
                              >
                                {isLoading ? "Creating..." : "Add"}
                              </Button>
                            </Form.Item> */}
                          </Form>
                        </Modal>
                      </div>

                      <div>
                        {loading ? (
                          <div className="text-center top-3 left-3">
                            <LoadingOutlined style={{ fontSize: "5rem" }} />
                          </div>
                        ) : (
                          <Table
                            dataSource={allCompanies}
                            columns={companiesColumns}
                            className="overflow-y-scroll"
                            scroll={{ x: "max-content" }}
                          />
                        )}
                      </div>
                      <Modal
                        title="Deactivate"
                        open={deactivateModal}
                        onOk={() => handleOk()}
                        onCancel={handleCancel}
                      >
                        <Form
                          form={form}
                          onFinish={() => handleCompanyStatus("deactivate")}
                        >
                          <Form.Item
                            name="reason"
                            label="Reason"
                            rules={[
                              {
                                required: true,
                                message: "Please enter deactivation reason.",
                              },
                            ]}
                          >
                            <TextArea />
                          </Form.Item>
                        </Form>
                      </Modal>
                      <Modal
                        title="Activate"
                        open={activeOpen}
                        onOk={() => handleCompanyStatus('Active')}
                        // onOk={() => handleCompanyActivate(companyId)}
                        onCancel={handleCancel}
                      >
                        <p>{modalText}</p>
                      </Modal>
                    </>
                  </TabPane>
                )}
                {(user_role === "superadmin" || user_role === "demo") && (
                  <TabPane className="relative" tab="Demo Requests" key="8">
                    {/* resulde model  */}
                    <Modal
                      title="Reschedule Meeting"
                      open={isRescheduleModalOpen}
                      onCancel={() => setIsRescheduleModalOpen(false)}
                      footer={null}
                      width={500}
                    >
                      {!rescheduleDate ? (
                        <Card className="mb-10px glass-card">
                          <Calendar
                            fullscreen={false}
                            defaultValue={dayjs()}
                            onSelect={(value) => setRescheduleDate(value.format("YYYY-MM-DD"))}
                            dateCellRender={dateCellRender}
                            disabledDate={(date) => !timezoneAdjustedData[date.format("YYYY-MM-DD")]}
                          />
                        </Card>
                      ) : !rescheduleTime ? (
                        <div>
                          <h3 className="text-center text-lg font-medium mb-2">Select Time</h3>
                          <div className="flex justify-between mb-4 items-center">
                            <div onClick={() => setRescheduleDate(null)} > <LeftOutlined /> </div>
                            <div className="mb-2 text-sm text-gray-400 text-center">
                              {getFormattedDate(rescheduleDate)} | 30 minutes
                            </div>
                            <div>

                            </div>
                          </div>
                          <List
                            style={{ maxHeight: "400px", overflowY: "auto" }}
                            dataSource={timezoneAdjustedData[rescheduleDate]}
                            renderItem={(time) => (
                              <List.Item>
                                <Button
                                  block
                                  type="primary"
                                  style={{
                                    backgroundColor:
                                      timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                        ? "transparent"
                                        : "#2563EB",
                                    borderColor: "#2563EB",
                                    color:
                                      timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                        ? "#000000"
                                        : "#ffffff"
                                  }}
                                  disabled={
                                    timezoneAdjustedUnavailable[rescheduleDate]?.includes(time) || isPast(rescheduleDate, time)
                                  }
                                  onClick={() => setRescheduleTime(time)}
                                >
                                  {timezoneAdjustedUnavailable[rescheduleDate]?.includes(time)
                                    ? `Not Available ${time}`
                                    : `Book ${time}`}
                                </Button>
                              </List.Item>
                            )}
                          />
                        </div>
                      ) : (
                        <div>
                          <h3 className="text-center text-lg font-medium mb-2 mt-8">Confirm Reschedule</h3>
                          <div className="flex justify-between items-center mb-4">
                            <div onClick={() => setRescheduleTime(null)} > <LeftOutlined /> </div>
                            <div className="text-center text-gray-600 mb-4">
                              {getFormattedDate(rescheduleDate)} | {rescheduleTime} - 30 minutes
                            </div>
                            <div>

                            </div>
                          </div>
                          <Button
                            type="primary"
                            block
                            onClick={async () => {
                              try {
                                setRescheduleLoading(true);
                                const { adjustedDate, adjustedTime } = convertTime(
                                  rescheduleTime,
                                  rescheduleDate,
                                  "Asia/Kolkata",
                                  selectedTimezone
                                );
                                const payload = {
                                  meeting_id: meetingIdToReschedule,
                                  new_date_time: `${adjustedDate}T${adjustedTime}`,
                                };
                                await axiosInstance.post(`/demo/reschedule/`, payload);
                                message.success("Meeting Rescheduled");
                                setIsRescheduleModalOpen(false);
                                fetchDemoRequests();
                                getDate()
                                setRescheduleDate(null);
                                setRescheduleTime(null);
                              } catch (error) {
                                message.error(error?.response?.data?.error || "Reschedule failed");
                              } finally {
                                setRescheduleLoading(false);
                              }
                            }}
                          >
                            Confirm Reschedule
                          </Button>
                        </div>
                      )}
                    </Modal>

                    {/* read detail model  */}
                    {isReadNotesModalOpen && (
                      <>
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            height: "100vh",
                            width: "100vw",
                            backgroundColor: "rgba(0, 0, 50, 0.3)", // bluish-gray transparent
                            zIndex: 9998, // less than note box
                          }}
                          onClick={() => setIsReadNotesModalOpen(false)} // Click on backdrop = close
                        />

                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            right: "0px",
                            transform: "translateY(-50%)",
                            width: "400px",
                            height: "80vh", // Adjust height as needed
                            maxHeight: "80vh",
                            backgroundColor: "#fff",
                            borderRadius: "8px 0 0 8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            zIndex: 9999,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          {/* Header */}
                          <div
                            style={{
                              padding: "10px 16px",
                              borderBottom: "1px solid #f0f0f0",
                              fontWeight: "bold",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              background: "#f7f7f7",
                            }}
                          >
                            Meeting Notes
                            <Button size="small" onClick={() => setIsReadNotesModalOpen(false)}>
                              Close
                            </Button>
                          </div>

                          {/* Chat Scroll Box */}
                          <div
                            ref={chatContainerRef}
                            style={{
                              flex: 1,
                              overflowY: "auto",
                              padding: "10px",
                              width: "400px",
                            }}
                          >
                            {noteLoading ? (
                              <Spin />
                            ) : noteList.length === 0 ? (
                              <Typography.Text>No notes yet.</Typography.Text>
                            ) : (
                              renderGroupedNotes()
                            )}
                          </div>

                          {/* Input Footer */}
                          <div style={{ padding: "10px", borderTop: "1px solid #f0f0f0" }}>
                            <Input.TextArea
                              rows={2}
                              placeholder="Write your note here..."
                              value={noteInput}
                              onChange={(e) => setNoteInput(e.target.value)}
                              style={{ marginBottom: 8 }}
                            />
                            <div className="flex justify-end">

                              <Button
                                type="primary"

                                loading={noteLoading}
                                onClick={handleNoteSubmit}
                              >
                                Add Note
                              </Button>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="text-black pb-3 px-2 flex items-center justify-between">
                      <h1 className="mt-1 text-3xl font-bold font-inter">Demo Requests</h1>
                    </div>
                    <Table
                      dataSource={demoRequests}
                      columns={[
                        {
                          title: "First Name",
                          dataIndex: "first_name",
                          key: "first_name",
                        },
                        {
                          title: "Last Name",
                          dataIndex: "last_name",
                          key: "last_name",
                        },
                        {
                          title: "Email",
                          dataIndex: "email",
                          key: "email",
                        },
                        {
                          title: "Contact No",
                          dataIndex: "contact_no",
                          key: "request_reason",
                        },
                        {
                          title: "Entity Name",
                          dataIndex: "entity_name",
                          key: "request_response_by",
                        },
                        {
                          title: "Request Date & Time",
                          dataIndex: "request_date",
                          key: "request_date",
                          render: (text) => new Date(text).toLocaleString(), // Format date
                        },
                        {
                          title: "Action",
                          key: "action",
                          render: (_, record) => (
                            <Space>
                              <HoverIcon
                                icon={<LaptopOutlined />}
                                tooltip="Goto Meet"
                                color={record.status === 'cancelled' ? "gray" : "#4E36A3"}
                                hoverBgColor={record.status === 'cancelled' ? "transparent" : "#4E36A3"}
                                onClick={() => { window.open(record?.meeting?.meet_link) }}
                                hoverColor={record.status === 'cancelled' ? "gray" : "white"}
                                disabled={record.status === 'cancelled' || loading.status && loading.id == record.id}
                              />
                              <HoverIcon
                                icon={<CalendarOutlined />}
                                tooltip="Reschedule Meet"
                                color={record.status === 'cancelled' ? "gray" : "#AF3A94"}
                                hoverBgColor={record.status === 'cancelled' ? "transparent" : "#AF3A94"}
                                onClick={() => { setSelectedRecord(record); setIsRescheduleModalOpen(true); setMeetingIdToReschedule(record?.meeting?.id) }}
                                hoverColor={record.status === 'cancelled' ? "gray" : "white"}
                                disabled={record.status === 'cancelled'}
                              />

                              <HoverIcon
                                icon={<ReadOutlined />}
                                tooltip="View / Add Note"
                                color={record.status === 'cancelled' ? "gray" : "Red"}
                                hoverBgColor={record.status === 'cancelled' ? "transparent" : "Red"}
                                onClick={() => { handleOpenNoteModal(record) }}
                                hoverColor={record.status === 'cancelled' ? "gray" : "white"}
                                disabled={record.status === 'cancelled'}
                              />
                            </Space>
                          ),
                        },
                      ]}
                      rowKey={(record) => record.id} // Ensure unique keys for rows
                      pagination={{ pageSize: 10 }}
                    />
                  </TabPane>
                )}
                {(user_role === "superadmin" || user_role === "support") && (
                  <>
                    <TabPane tab="Tickets" key="9">
                      <TicketList />
                    </TabPane>
                    <TabPane tab="Meeting" key="10">
                      <Meeting />
                    </TabPane>
                  </>
                )}
              </Tabs>
            </Form>
            <div
              style={{
                position: "relative",
                bottom: 0,
                left: 0,
                display: "flex",
                justifyContent: "flex-start",
                paddingTop: "30px",
              }}
            >
              {activeTab !== "1" && (
                <ButtonComp
                  text="Previous"
                  textColor="#4E36A3"
                  bgColor="white"
                  onClick={handlePrevious}
                  margin="2rem"
                />
              )}
              {parseInt(activeTab) !== parseInt(finalPage) ? (
                <>
                  {editMode ? (
                    ""
                  ) : (
                    <ButtonComp
                      text="Next"
                      bgColor="#4E36A3"
                      textColor="white"
                      onClick={handleNext}
                    />
                  )}
                </>
              ) : (
                <>
                  {editMode ? (
                    ""
                  ) : (
                    <ButtonComp
                      text="Finish"
                      bgColor="#4E36A3"
                      textColor="white"
                      onClick={handleNext}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <div>
        <DocumentEditor
          id="docxEditor"
          documentServerUrl="http://documentserver/"
          config={{
            document: {
              fileType: "docx",
              key: "Khirz6zTPdfd7",
              title: "Example Document Title.docx",
              url: "https://example.com/url-to-example-document.docx",
            },
            documentType: "word",
            editorConfig: {
              callbackUrl: "https://example.com/url-to-callback.ashx",
            },
          }}
        />
      </div>
    </>
  );
}

export default SettingsPage;
